import React from 'react';
import { Box, Typography, TypographyProps } from '@mui/material';
import { Row } from '../../../components';

export const toggleButtonStyle: React.CSSProperties = { height: '45px', width: '130px' };

interface FormFieldRowProps {
  label: string;
  subLabel?: string;
  labelVariant?: TypographyProps['variant'];
  labelColor?: TypographyProps['color'];
  children?: React.ReactNode;
}

const FormFieldRow: React.FC<FormFieldRowProps> = ({
  label,
  subLabel,
  labelVariant = 'p16',
  labelColor = 'info.main',
  children,
}) => {
  return (
    <Row style={{ flexWrap: 'wrap', gap: '20px', alignItems: 'center' }}>
      <Typography
        component='div'
        sx={{ width: '30%', textAlign: 'right', minWidth: '200px' }}
        variant={labelVariant}
        color={labelColor}>
        {label}
        {subLabel && (
          <Typography component='div' variant='p12' color='info.disabled' sx={{ mt: '3px' }}>
            {subLabel}
          </Typography>
        )}
      </Typography>

      {children && <Box sx={{ minWidth: 0 }}>{children}</Box>}
    </Row>
  );
};

export default FormFieldRow;
